import { UserRole } from '../authentication/authentication.types';
import { StatusType } from '../api.types';
import { BackendIntegrationType } from '../core/core.types';

export interface NotificationModel {
  id: number;
  title: string;
  text: string;
  important: boolean;
  expiresAfter: string;
  suppliers: { code: string }[];
}

export interface SupplierNotificationModel {
  id: number;
  title: string;
  text: string;
  important: boolean;
}

export interface NotificationRequestModel {
  title: string;
  text: string;
  important: boolean;
  expiresAfter: string;
  suppliers: { code: string }[];
}

export interface SupplierModel {
  code: string;
  name: string;
  tableauLogin: string;
  tableauInsightsUrl: string;
  tableauBillingUrl: string;
  hasBookingWeb: boolean;
  maxRentalDuration: number;
  baseCurrencyCode: string;
  backendIntegrationType?: BackendIntegrationType;
  notifications: SupplierNotificationModel[];
}

/*
* Classifiers
*/

export interface ClassifierTypeModel {
  name: string;
  code: string;
}

export interface ClassifierModel {
  code: string;
  classifierType: string;
  statusType: StatusType;
  name: string;
  description: string;
  stringValue: string;
  longValue: number;
}

export interface EditClassifierRequest {
  statusType: StatusType;
  name: string;
  description: string;
  stringValue: string;
  longValue: number;
}

export interface ClassifierListFilters {
  code?: string;
  name?: string;
  value?: string;
  description?: string;
  classifierTypeCode?: string;
}

export enum ClassifierTypes {
  CAR_MODEL_FEATURE = 'CAR_MODEL_FEATURE',
  CURRENCY = 'CURRENCY',
  ITEM_OTA_CODE = 'ITEM_OTA_CODE',
  COUNTRY = 'COUNTRY'
}

/*
* Brokers
*/

export interface BrokerModel {
  id: number;
  name: string;
  statusType: StatusType;
  comment: string;
  legalName: string;
  supplierCodes: string[];
}

export interface EditBrokerRequest {
  name: string;
  legalName: string;
  statusType: StatusType;
  comment: string;
}

export interface SupplierBrokerModel {
  id: number;
  name: string;
  statusType: StatusType;
  comment: string;
  legalName: string;
  additionalData: SupplierBrokerAdditionalData;
  supplierReferenceCode: string;

}

export interface EditSupplierBrokerRequest {
  agentId: string;
  referralId: string;
  sourceCode: string;
  companyId: string;
  supplierReferenceCode: string;
}

interface SupplierBrokerAdditionalData {
  agentId: string;
  referralId: string;
  sourceCode: string;
  companyId: string;
}

export const adminModuleEditRoles = [ UserRole.RATE_CHAIN_ADMIN, UserRole.RATE_CHAIN_SUPPORT ];
export const adminModuleViewRoles = [ UserRole.RATE_CHAIN_ADMIN, UserRole.RATE_CHAIN_SUPPORT, UserRole.SUPPLIER_ADMIN ];
export const userModuleEditRoles = [ UserRole.RATE_CHAIN_ADMIN, UserRole.RATE_CHAIN_SUPPORT, UserRole.SUPPLIER_ADMIN ];
export const brokerModuleEditRoles = [ UserRole.RATE_CHAIN_ADMIN, UserRole.RATE_CHAIN_SUPPORT, UserRole.SUPPLIER_ADMIN ];
export const manageBrokerModuleEditRoles = [ UserRole.RATE_CHAIN_ADMIN, UserRole.RATE_CHAIN_SUPPORT];
export const supplierModuleEditRoles = userModuleEditRoles;

